export default "__VITE_ASSET__DjrLmMOB__"